import React from "react";
import { motion } from "framer-motion";
import DocumentListView from "../Views/DocumentListView";
import "./Styles/MainPage.scss";

const MainPage: React.FC = () => {

  return (
    <motion.div className="MainPageWrapper">
      <DocumentListView />
    </motion.div>
  );
};

export default MainPage;
